import { createContext } from 'react';
const context = createContext({});

export default context;

const { Provider, Consumer } = context;
export { Provider, Consumer };
